module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "similar-answers"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.isAnswer ? '相关问答' : '相关文章'))]), _vm._v(" "), (_vm.similarList.length) ? _c('div', {}, [_c('ul', {
    staticClass: "similar-answers-lists"
  }, _vm._l((_vm.similarList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "similar-item"
    }, [_c('div', {
      staticClass: "left-info"
    }, [_c('img', {
      attrs: {
        "src": require("../../images/community/eye-open.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.no_of_views))])]), _vm._v(" "), _c('div', {
      staticClass: "right-words",
      on: {
        "click": function($event) {
          return _vm.goQuestionList(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('loading', {
    staticStyle: {
      "padding": "100px 0",
      "background-color": "#ffffff",
      "margin": "0"
    },
    attrs: {
      "ifLoadingStart": _vm.isSimilarLoading
    }
  }), _vm._v(" "), (!_vm.isSimilarLoading && this.similarList.length === 0) ? _c('div', {
    staticClass: "attention-null"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/developer/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("未有相关问答！")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-76ed9e1e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/communityRightContent.vue
// module id = iQg6
// module chunks = 16